export default __webpack_public_path__ + "static/Graphik-Medium-Web-8dd30e30aec32c2b24bc3d2fa137ed17.woff2";